const NAME = "DIGITAL_FOLDER_SETTINGS_PAGE";

export default NAME;
